// Add your custom JS here.

// Get the element to animate
const element = document.querySelector('.fade-in-scroll-in');
// Element to observe to trigger menu animation
const triggerElementToAnimateMenu = document.querySelector('.wp-block-cover')
const menuElementsToAnimate = document.querySelectorAll('.custom-logo-link img,.navbar-nav,.navbar-toggler,.contact-btns');
// Define the options for the Intersection Observer
const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.33
};

// Options for menuObserver
const optionsMenuObserver = {
  root: null,
  rootMargin: '0px',
  threshold: 0
};

// Create a new Intersection Observer
const observer = new IntersectionObserver(function(entries, observer) {
  entries.forEach(entry => {
    // If element is in viewport, add the 'show' class to trigger the animation
    if (entry.isIntersecting) {
      element.classList.add('show');
    }
    else {
      element.classList.remove('show');
    }
  });
}, options);
// Create Intersection Observer for menu
const observerForMenu = new IntersectionObserver(function(entries, observer) {
  entries.forEach(entry => {
    // If element is in viewport, add the 'small' class to trigger the animation
    if (entry.isIntersecting) {
      menuElementsToAnimate.forEach(function(currentValue) {
        currentValue.classList.remove('smaller');
      });
    }
    else {
      menuElementsToAnimate.forEach(function(currentValue) {
        currentValue.classList.add('smaller');
      });
    }
  });
}, optionsMenuObserver);
// Start observing the element
document.addEventListener("DOMContentLoaded", function(){
  // your instersectionobserver code here
  (element instanceof Element) ? observer.observe(element) : "" ;
  
  (triggerElementToAnimateMenu instanceof Element) ? observerForMenu.observe(triggerElementToAnimateMenu) : "";
});

